import Crud from '../views/Logs/Crud'

let routes = {
    path: '/logs',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/logs',
            name: 'list-logs',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Logs',
                breadcrumb: [
                    {
                        text: 'logs',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
